export const MediaTypeEnum = {
  typeImg: ['png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG', 'bmp', 'BMP', 'gif', 'GIF', 'webp', 'WEBP', 'psd', 'PSD', 'svg', 'SVG', 'tiff', 'TIFF'], // 图片类型
  typeVideo: ['avi', 'AVI', 'wmv', 'WMV', 'mpg', 'MPG', 'mpeg', 'MPEG', 'mov', 'MOV', 'rm', 'RM', 'ram', 'RAM', 'swf', 'SWF', 'flv', 'FLV', 'mp4', 'MP4'], // 视频类型
  typeAudio: ['cda', 'CDA', 'wav', 'WAV', 'mp3', 'MP3', 'aif', 'AIF', 'aiff', 'AIFF', 'mid', 'MID', 'wma', 'WMA', 'ra', 'RA', 'vqf', 'VQF', 'ape', 'APE'] // 音频类型
};

